import { themeFontsAndColorsCompNode } from './themeFontsAndColorsCompNode'
import { ThemeFontsAndColorsCssFeature } from './themeFontsAndColors.types'
import { themeFontsAndColorsDomApplier } from './themeFontsAndColorsDomApplier'

export const themeFontsAndColorsCssFeature: ThemeFontsAndColorsCssFeature = {
	experimentName: 'specs.thunderbolt.theme_fonts_colors_catharsis',
	renderableNodes: { themeFontsAndColorsCssStyle: themeFontsAndColorsCompNode },
	intermediateNodes: {},
	dataMaps: ['theme_data'],
	domApplier: themeFontsAndColorsDomApplier,
}
